export const utilsWithChainNetwork = (utils, getClassNetwork) => ({
    ...utils,
    addressIsValid: (address, network) => utils.addressIsValid(address, network || getClassNetwork() || "mainnet"),
    addressExplorerLink: utils.addressExplorerLink
        ? (address, network) => 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-unnecessary-type-assertion
        utils.addressExplorerLink(address, network || getClassNetwork() || "mainnet")
        : undefined,
    transactionExplorerLink: utils.transactionExplorerLink
        ? (tx, network) => 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-unnecessary-type-assertion
        utils.transactionExplorerLink(tx, network || getClassNetwork() || "mainnet")
        : undefined,
});
//# sourceMappingURL=chainUtils.js.map